import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Listing, PropertiesService } from '@app/shared/services/properties/properties.service';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-set-lead-listing',
  templateUrl: './dialog-set-lead-listing.component.html',
  styleUrls: ['./dialog-set-lead-listing.component.scss'],
})
export class DialogSetLeadListingComponent implements OnInit {
  setting: boolean = false;

  constructor(
    private readonly propertiesService: PropertiesService,
    public dialogRef: MatDialogRef<DialogSetLeadListingComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      listing: Listing;
    }
  ) { }

  ngOnInit() { }

  confirmAsLeadListing() {
    this.setting = true;

    this.propertiesService
      .setListingAsLeadListing(
        this.dialogData.listing.property.id,
        this.dialogData.listing.listing_id,
        this.dialogData.listing.platform_key
      )
      .subscribe(
        (res) => {
          if (res) {
            // success
            this.setting = false;

            this.dialogRef.close(true);
          } else {
            this.setting = false;
          }
        },
        (err) => {
          this.setting = false;
        }
      );
  }

  cancelClicked() {
    this.dialogRef.close(false);
  }
}
